// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.col-number {
  width: 55px;
  min-width: 55px;
  max-width: 55px;
  white-space: nowrap;
}

.col-edit, .col-delete {
  width: 45px;
  min-width: 45px;
  max-width: 45px;
  padding-left: 4px !important;
  padding-right: 0 !important;
  white-space: nowrap;
}

.table-toolbar {
  margin-bottom: 10px;
}

.responsive-table {
  max-height: 68vh;
  overflow: auto;
}

.materials-table {
  width: 100%;
  font-size: 0.875rem;
}
.materials-table th {
  white-space: nowrap;
  background-color: #0066b2;
  color: #fff;
  position: sticky;
  top: 0;
  z-index: 2;
}
.materials-table tr.selected-row td {
  background-color: #e3f2fd;
}

.empty-state {
  color: #666;
  padding: 16px 0;
  font-style: italic;
}

.pagination-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
}

.pagination-info {
  font-size: 0.8rem;
  color: #555;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/inventory/inventory-dialog/materials-table/materials-table.component.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAGA;EACE,WAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;AAFF;;AAKA;EACE,WAAA;EACA,eAAA;EACA,eAAA;EACA,4BAAA;EACA,2BAAA;EACA,mBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,cAAA;AAFF;;AAKA;EACE,WAAA;EACA,mBAAA;AAFF;AAIE;EACE,mBAAA;EACA,yBCjCU;EDkCV,WAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;AAFJ;AAKE;EACE,yBAAA;AAHJ;;AAOA;EACE,WAAA;EACA,eAAA;EACA,kBAAA;AAJF;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AAJF;;AAOA;EACE,iBAAA;EACA,WAAA;AAJF","sourcesContent":["\n@use '../../../../../styles/colors' as colors;\n\n.col-number {\n  width: 55px;\n  min-width: 55px;\n  max-width: 55px;\n  white-space: nowrap;\n}\n\n.col-edit, .col-delete {\n  width: 45px;\n  min-width: 45px;\n  max-width: 45px;\n  padding-left: 4px !important;\n  padding-right: 0 !important;\n  white-space: nowrap;\n}\n\n.table-toolbar {\n  margin-bottom: 10px;\n}\n\n.responsive-table {\n  max-height: 68vh;\n  overflow: auto;\n}\n\n.materials-table {\n  width: 100%;\n  font-size: 0.875rem;\n\n  th {\n    white-space: nowrap;\n    background-color: colors.$medium-blue;\n    color: #fff;\n    position: sticky;\n    top: 0;\n    z-index: 2;\n  }\n\n  tr.selected-row td {\n    background-color: #e3f2fd;\n  }\n}\n\n.empty-state {\n  color: #666;\n  padding: 16px 0;\n  font-style: italic;\n}\n\n.pagination-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 8px;\n}\n\n.pagination-info {\n  font-size: 0.8rem;\n  color: #555;\n}\n","$dark-blue: #0b2d71;\n$medium-blue: #0066b2;\n$light-blue: #009dd9;\n$dark-teal: #003653;\n$medium-teal: #00708c;\n$light-teal: #00b2bd;\n$dark-green: #444b0d;\n$medium-green: #769231;\n$light-green: #b2cc34;\n$dark-orange: #711b00;\n$medium-orange: #e5601f;\n$light-orange: #faab18;\n$dark-red: #58001c;\n$medium-red: #97002e;\n$light-red: #e21836;\n$lighter-red: rgb(247, 235, 239);\n$dark-purple: #3a0d36;\n$medium-purple: #751269;\n$light-purple: #ba3093;\n\n$dark-gray: #6b6d6f;\n$medium-gray: #8c8f93;\n$light-gray: #dbdcdd;\n$lighter-gray: #ECECEC;\n$lightest-gray: #f7f7f7; //alternative background-gray\n$lightest-gray2: #f3f3f3;\n\n$black: #000000;\n$white: #ffffff;\n$background-gray: #ededee;\n\n$highlight-blue: #E4F4FA; // for table highlights only\n$lighter-blue: #E4ECF2;\n$primary-blue: #007bff;\n$highlight-yellow: #E3F1A2;\n$highlight-peach: #FFE594;\n$highlight-neon: #FFA4C0;\n$success: #00708c;\n$warning: #faab18;\n$error: #97002e;"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
